import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheTesteurQA = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🧪 Recruter un Testeur QA
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Testeur QA (Quality Assurance) garantit la qualité fonctionnelle et technique des applications avant, pendant et après leur mise en production. Il conçoit des plans de tests, identifie les anomalies, et s’assure que les produits livrés répondent aux exigences métiers et utilisateurs. Indispensable en environnement agile, il contribue à améliorer la fiabilité, la performance et l’expérience utilisateur.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Rédiger des plans de tests (fonctionnels, techniques, de non-régression)</li>
          <li>Réaliser les campagnes de tests manuels ou automatisés</li>
          <li>Identifier, reproduire et remonter les bugs aux développeurs</li>
          <li>Suivre la résolution des anomalies et documenter les tests</li>
          <li>Participer aux rituels agiles (daily, sprint planning, démos, etc.)</li>
          <li>Contribuer à l’amélioration continue du processus qualité</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Méthodologies : Agile, Scrum, ISTQB</li>
          <li>Outils : Jira, TestRail, Postman, Selenium, Playwright, Cypress</li>
          <li>Langages de scripting pour l’automatisation (JavaScript, Python, Java…)</li>
          <li>Connaissances techniques front-end / back-end appréciées</li>
          <li>Rigueur, esprit d’analyse, sens du détail et communication claire</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : exécution de plans de tests manuels, montée en compétence en automatisation</li>
          <li>Confirmé : maîtrise des tests automatisés, participation active aux sprints</li>
          <li>Senior : définition de stratégie QA, automatisation complète, gestion de la qualité à l’échelle</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 300–400 € / jour</li>
          <li>Confirmé : 450–600 € / jour</li>
          <li>Senior : 650–800 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheTesteurQA;
